export default __webpack_public_path__ + "static/media/Lupa_on.d12f6f7b.svg";